import React, { useEffect } from 'react'
import Navbar from '../../Navbar'
import Footer from '../../Footer'
const Refundpolicy = () => {
    useEffect(() => {
    window.scrollTo(0,0)
    }, [])
    
  return (
    <>
        <Navbar/>
          <section id='p-policy'>
                <div className='or-div'>
                    <h1>Refund Policy </h1>
                </div>

                <div className="container ">


                    <div className='mt-opo holo'>
                        <h2>How do I cancel my Order?</h2>
                        <ol>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam quibusdam, nisi corporis doloribus, tenetur reiciendis impedit dignissimos deleniti vero ex repudiandae reprehenderit dolor recusandae delectus nam? Ducimus sapiente ea architecto..</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestias eaque nulla placeat quidem esse laudantium repellendus provident, ad consequuntur officia magnam tenetur. Vel sequi magnam nulla, eos ratione nobis quasi.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>

                        </ol>
                    </div>
                    <div className='mt-opo holo'>
                        <h2>How do I cancel my Order?</h2>
                        <ol>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora, corporis nisi? Molestiae earum, deserunt, illo amet voluptate fugiat a reprehenderit labore ratione asperiores placeat culpa ullam voluptates ipsa accusantium recusandae.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero ipsum quos soluta harum delectus eligendi aspernatur sunt quisquam velit, quam in quia consectetur, adipisci quidem fugit distinctio consequatur minima suscipit!</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>

                        </ol>
                    </div>
                    <div className='mt-opo holo'>
                        <h2>How do I cancel my Order?</h2>
                        <ol>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reiciendis sint laborum excepturi. Unde sint maxime doloribus quibusdam temporibus sapiente animi, repellat earum reprehenderit cupiditate? Vero suscipit iste eum optio aliquid.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>

                        </ol>
                    </div>
                    <div className='mt-opo holo'>
                        <h2>How do I cancel my Order?</h2>
                        <ol>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>

                        </ol>
                    </div>

                 
                   
                </div>
            </section>
            <Footer/>
    </>
  )
}

export default Refundpolicy